import React, { useEffect, useState, useRef } from "react";
import logo from "../assets/images/logo.jpeg";

const Preloader = ({ show }) => {
  const [visible, setVisible] = useState(false);
  const startTimeRef = useRef(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (show) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      startTimeRef.current = Date.now();
      setVisible(true);
    } else {
      const elapsed = Date.now() - startTimeRef.current;
      const minDuration = 1000; // 1 second minimum display

      const hidePreloader = () => {
        setVisible(false);
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("preloader:hidden"));
        }
      };

      if (elapsed >= minDuration) {
        hidePreloader();
      } else {
        const remaining = minDuration - elapsed;
        timeoutRef.current = setTimeout(() => {
          hidePreloader();
        }, remaining);
      }
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [show]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/70 backdrop-blur-md z-[99999] flex flex-col justify-center items-center select-none animate-[fadeIn_0.2s_ease-out]">
      {/* Dynamic styles to handle fade in animation */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
      
      <div className="relative flex items-center justify-center">
        {/* Outer glowing pulsing amber ring */}
        <div className="absolute w-36 h-36 rounded-full border border-amber-500/10 animate-ping opacity-75" />
        
        {/* Secondary decorative dotted ring */}
        <div className="absolute w-32 h-32 rounded-full border border-dashed border-slate-700/60" />
        
        {/* Rotating brand amber circle */}
        <div className="w-24 h-24 rounded-full border-[3px] border-amber-500/10 border-t-amber-500 border-r-amber-500 animate-spin" />
        
        {/* Reverse rotating dashed inner circle */}
        <div className="absolute w-18 h-18 rounded-full border-[2px] border-dashed border-amber-500/30 animate-[spin_2s_linear_infinite_reverse]" />
        
        {/* Center glowing logo image */}
        <div className="absolute w-14 h-14 rounded-full overflow-hidden border border-amber-500/30 shadow-[0_0_16px_rgba(245,158,11,0.4)] bg-white flex items-center justify-center">
          <img src={logo} alt="Logo" className="w-full h-full object-cover" />
        </div>
      </div>
      
      {/* Elegant Loading Label */}
      <h3 className="mt-8 text-xs font-black tracking-[0.25em] text-slate-100 uppercase">
        Loading
      </h3>
      
      {/* Secondary micro instructions */}
      <p className="mt-1.5 text-[9px] font-bold text-amber-500/80 uppercase tracking-[0.18em] animate-pulse">
        Please wait
      </p>
    </div>
  );
};

export default Preloader;
